import { Box, Typography, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useRecoilValue } from 'recoil';
import { styled } from 'styled-components';
import { useDashboardActions } from '../../../states/dashboard/dashboard.actions';
import { authAtom } from '../../../states/usuarios/AuthState';
import Consultor from './Consultor';
import DashboardCard from './DashboardCard';
import { useAcoesActions } from '../../../states/acao/acao.actions';
import { useTranslation } from '../../../commons/useTranslasion';
import { ptBR, esES } from '@mui/material/locale';
import { history } from '../../../helpers/history';
import { useComandasActions } from '../../../states/comandas/comandas.actions';
import moment from 'moment';
import Noticias from './Noticias';
import { useDateFormatters } from '../../../utils/useDateFormatters';

export interface IDashboard {
  etapasConcluidas: number;
  empresasSelecionadas: number;
  oportunidades: number;
  eventos: number;
  headhuntersSelecionados: number;
}

const Dashboard: React.FC = () => {
  const { translate, language } = useTranslation();
  const { formatarData } = useDateFormatters();
  const lang = language ?? "pt-br";
  let locale = ptBR;
  switch (lang.slice(0, 2)) {
    case "es":
      locale = esES
      break;
  }

  const auth = useRecoilValue(authAtom);
  const comandasActions = useComandasActions();
  const actions = useDashboardActions();
  const acaoActions = useAcoesActions();

  const [loading, setLoading] = useState(true);
  const [dashboard, setDashboard] = useState<IDashboard>();
  const [acoesIndicacao, setAcoesIndicacao] = useState<number>(0);
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [reunioesParaAprovar, setReunioesParaAprovar] = useState<any[]>([]);
  const [etapas, setEtapas] = useState<any[]>([]);

  useEffect(() => {
    actions
      .get()
      .then((data) => setDashboard(data))
      .catch((e) => toast.error(translate('erroAoBuscarDashboard')))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    acaoActions.list()
      .then((data) => {
        const acoes = data.filter((acao: any) =>
          acao.idTipoNavigation.nome === 'Indicação p/ Vaga Anunciada' ||
          acao.idTipoNavigation.nome === 'Indicação p/ HeadHunter' ||
          acao.idTipoNavigation.nome === 'Indicação p/ Vaga Aprovada'
        );

        setAcoesIndicacao(acoes.length)
      })
      .catch(() => toast.error(translate('erroAoBuscarAcoes')))

  }, [auth?.comanda?.id!]);

  useEffect(() => {
    comandasActions
      .list()
      .then((resp: any) => {
        const reunioes = resp.comandaEtapaReunioes?.filter(
          (reuniao: any) => reuniao.status === 'PENDENTE_APROVACAO'
        );

        if (reunioes && reunioes.length) {
          setReunioesParaAprovar(reunioes);
          setEtapas(resp.etapas);
          setOpenDialog(true);
        }
      })
      .catch((e: any) => {
        toast.error(e);
      });
  }, [auth?.comanda?.id]);

  return (
    <>
      <DivDashboard>
        <Typography variant="h1">{translate('bemVindo')}, {auth?.nome ? auth!.nome.split(' ')[0] : ''}!</Typography>
        <Typography variant="body1" sx={{ marginTop: '16px' }}>
          {translate('descricaoDashboard')}
        </Typography>
        <Consultor />

        <Noticias />

        <Box
          sx={{
            flexGrow: 1,
            marginTop: '0px',
            display: 'flex',
            flexWrap: 'wrap',
            gap: '16px',
            justifyContent: 'center',
          }}
        >
          <DashboardCard title={translate('etapasConcluidas')} value={dashboard?.etapasConcluidas} percentageChange={0} />
          <DashboardCard title={translate('indicacoes')} value={(0) + acoesIndicacao} percentageChange={0} />
          <DashboardCard title={translate('eventos')} value={dashboard?.eventos} percentageChange={0} />
        </Box>
      </DivDashboard>

      <>
        <Dialog
          open={openDialog}
          onClose={() => setOpenDialog(false)}
          aria-labelledby="reunioes-dialog-title"
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle id="reunioes-dialog-title">
            {translate('reunioesParaAprovar')}
          </DialogTitle>
          <DialogContent>
            <Typography variant="body1" sx={{ mb: 2 }}>
              {translate('vocePossuiReunioesAguardandoAprovacao')}
            </Typography>

            {reunioesParaAprovar.map((reuniao) => (
              <>
                {etapas.find((e) => e.id === reuniao.tbEtapaId) && (
                  <Box
                    key={reuniao.id}
                    sx={{
                      p: 2,
                      mb: 2,
                      border: '1px solid #e0e0e0',
                      borderRadius: '4px',
                      backgroundColor: '#f9f9f9'
                    }}
                  >
                    <Typography variant="h6" component="h3">
                      {etapas.find((e) => e.id === reuniao.tbEtapaId)?.nome}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {formatarData(reuniao.dtRealizadaInicio)} - {formatarData(reuniao.dtRealizadaFim)}
                    </Typography>
                  </Box>
                )}
              </>
            ))}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenDialog(false)} color="primary">
              {translate('fechar')}
            </Button>
            <Button
              onClick={() => {
                history.push('/minha-transicao/programa')
                setOpenDialog(false);
              }}
              variant="contained"
              color="primary"
            >
              {translate('verReunioes')}
            </Button>
          </DialogActions>
        </Dialog>
      </>
    </>
  );
};

const DivDashboard = styled.div`
  width: 100%;
  margin-top: 100px;
  padding: 64px 32px 0px;
`;

export default Dashboard;
